import { render, staticRenderFns } from "./py.vue?vue&type=template&id=8a663e06&scoped=true"
import script from "./py.vue?vue&type=script&lang=js"
export * from "./py.vue?vue&type=script&lang=js"
import style0 from "./py.vue?vue&type=style&index=0&id=8a663e06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a663e06",
  null
  
)

export default component.exports